export default __webpack_public_path__ + "static/media/2.abe02da5.jpg";